import { render, staticRenderFns } from "./Transition.vue?vue&type=template&id=1d3b1520&scoped=true"
import script from "./Transition.vue?vue&type=script&lang=js"
export * from "./Transition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3b1520",
  null
  
)

export default component.exports